import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useOverlayContext } from 'seagull';
import { DefaultToSUpdateNotice } from '~/components/DefaultToSUpdateNotice/DefaultToSUpdateNotice';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { legalTermsModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
export const useDefaultToSUpdateNotice = (param)=>{
    let { snapshot, onViewUpdatedTerms } = param;
    const { UPDATE_DEFAULT_TOS_FE } = useFeatureFlags();
    const { showModal } = useOverlayContext();
    const userClientData = useStore((state)=>state.userClientData);
    const isVendor = useStore(selectors.user.isVendor);
    const isImpersonating = useStore((state)=>selectors.impersonatingAs(state) != null);
    const { updateUserClientData } = useStoreActions();
    const hasShownRef = useRef(false);
    const onViewUpdatedTermsRef = useRef(onViewUpdatedTerms);
    useEffect(()=>{
        onViewUpdatedTermsRef.current = onViewUpdatedTerms;
    });
    useEffect(()=>{
        if (!UPDATE_DEFAULT_TOS_FE) return;
        if (isImpersonating) return;
        if (!isVendor) return;
        if (snapshot == null) return;
        if (!legalTermsModel.isCurrentAnchorDefault(snapshot)) return;
        if (!legalTermsModel.wasMigrated(snapshot)) return;
        if ((userClientData === null || userClientData === void 0 ? void 0 : userClientData.defaultToSUpdateNoticeDismissed) === true) return;
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        const persistDismissal = async ()=>{
            await updateUserClientData({
                defaultToSUpdateNoticeDismissed: true
            });
        };
        showModal({
            biName: 'default_tos_update_notice',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(DefaultToSUpdateNotice, {
                    onDismiss: async ()=>{
                        await persistDismissal();
                        dismissModal();
                    },
                    onViewUpdatedTerms: async ()=>{
                        var _onViewUpdatedTermsRef_current;
                        await persistDismissal();
                        dismissModal();
                        (_onViewUpdatedTermsRef_current = onViewUpdatedTermsRef.current) === null || _onViewUpdatedTermsRef_current === void 0 ? void 0 : _onViewUpdatedTermsRef_current.call(onViewUpdatedTermsRef, snapshot);
                    }
                });
            }
        });
    }, [
        UPDATE_DEFAULT_TOS_FE,
        isImpersonating,
        isVendor,
        snapshot,
        userClientData === null || userClientData === void 0 ? void 0 : userClientData.defaultToSUpdateNoticeDismissed
    ]);
};
